var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudCoverTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2413,9.2571c-1.084-1.1357-2.5742-1.8416-4.2193-1.8728 c-0.6152-1.2471-1.5117-2.3169-2.5995-3.1199c-1.3657-1.0081-3.0317-1.5979-4.8286-1.5979c-2.3398,0-4.4597,0.9976-5.9822,2.6714 C3.339,6.7368,2.4822,8.6152,2.2965,10.7751c-0.5621,0.3574-1.0494,0.8315-1.4288,1.3923C0.3228,12.9726,0,13.9558,0,15.0176 c0,1.3667,0.5339,2.6016,1.3879,3.4966C2.2681,19.4363,3.4857,20,4.8264,20h13.2444c1.6589-0.0464,3.1577-0.7776,4.2361-1.9434 C23.3516,16.9275,24,15.3896,24,13.6909C24,11.958,23.3243,10.3918,22.2413,9.2571z M20.8391,16.698 c-0.7441,0.8047-1.7363,1.2656-2.7988,1.3018H4.8264c-0.751,0-1.459-0.3076-1.9912-0.8662c-0.5381-0.5635-0.835-1.3154-0.835-2.1162 c0-0.625,0.1807-1.2227,0.5234-1.7285c0.2236-0.3311,0.5166-0.6172,0.8467-0.8262l0.833-0.5312l0.085-0.9844 c0.1426-1.6494,0.7666-3.124,1.8027-4.2637c1.1826-1.3008,2.7822-2.0166,4.5029-2.0166c1.3125,0,2.5713,0.417,3.6406,1.207 c0.835,0.6162,1.5244,1.4443,1.9932,2.3955l0.5391,1.0918l1.2168,0.0234c1.0605,0.0195,2.0586,0.4648,2.8105,1.2529 c0.7783,0.8154,1.2061,1.8994,1.2061,3.0537C22.0002,14.821,21.5881,15.8884,20.8391,16.698z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCoverTomorrowio);
export default __webpack_public_path__ + "static/media/cloud-cover-tomorrowio.fad471216f2013c8bb625451790bb853.svg";
export { ForwardRef as ReactComponent };